
export type GetTweetById200Tags = {
  hashtagIds?: string[];
};
